import { Box, Typography, LinearProgress } from "@mui/material";
import React, { Fragment, useMemo } from "react";
import { LocationAvailabilitiesBeachChairsStyle } from "../../../utils/hooks/styles/locationAvailabilitiesBeachChairsStyle";

import {
  selectBeachChairRequest,
  setRowRequest,
} from "../../../store/reducers/availabilityReducer";
import AvailabilitiesBeachChair from "./availabilitiesBeachChair";
import { useTranslation } from "react-i18next";
import { redirectRequest } from "../../../store/reducers/mainAppReducer";
import { getVendorSelector } from "../../../store/selectors/vendorSelectors";
import { getSelectedCitySelector } from "../../../store/selectors/citySelectors";
import { getSelectedBeachChairSelector } from "../../../store/selectors/bookingSelectors";
import {
  getAllBookedBeachChairs,
  selectBeachChairToBookingRequest,
} from "../../../store/reducers/bookingReducer";
import { isDisabled } from "../../../utils/checkers/isDisabled";
import { useAppDispatch } from "../../../store";
import { useSelector } from "react-redux";
import {
  getPendingAvailabilitiesSelector,
  getRowIdSubSectionSelector,
  getSectionsSelector,
} from "../../../store/selectors/availabilitySelectors";
import {
  getDateFromSelector,
  getDateToSelector,
} from "../../../store/selectors/mainAppSelectors";
import { getSelectedSectionSelector } from "../../../store/selectors/sectionSelectors";
import RowDivider from "../rowDivider/rowDivider";
import { getPreBookingInfo } from "../../../utils/functions/bookingStart";

export const formatDate = (year: Number, season: String) => {
  const seasonMonthDay = season.split("-");
  return new Date(+year, +seasonMonthDay[1] - 1, +seasonMonthDay[0]);
};

const AvailabilitiesBeachChairs = () => {
  const showColor = true;
  const { t } = useTranslation("availabilities");
  const dispatch = useAppDispatch();
  const selectedId = useSelector(getSelectedBeachChairSelector);
  const rowId = useSelector(getRowIdSubSectionSelector);
  const inBookingSelectedIds = useSelector(getAllBookedBeachChairs);
  const section = useSelector(getSelectedSectionSelector);
  const city = useSelector(getSelectedCitySelector);
  const rows = useSelector(getSectionsSelector);
  const pending = useSelector(getPendingAvailabilitiesSelector);
  const vendor = useSelector(getVendorSelector);
  const start = useSelector(getDateFromSelector);
  const end = useSelector(getDateToSelector);

  const displayRows = useMemo(() => {
    return (
      rows.some((row) => !!row?.rowData?.length)
    );
  }, [rows]);

  const preBooking = getPreBookingInfo(vendor);

  return (
    <>
      {displayRows && vendor?.configuration.gridLineBreak && (
        <Box sx={LocationAvailabilitiesBeachChairsStyle.noDataText}>
          {t("availabilities:beachChairPosition")}
        </Box>
      )}
      {pending ? (
        <LinearProgress />
      ) : displayRows ? (
        rows
          ?.filter((row) => rowId === undefined || row.id === rowId)
          .map(
            (row) =>
              row.rowData.length > 0 && (
                <Fragment key={`${row.id}-${row.name}`}>
                  <Box
                    sx={LocationAvailabilitiesBeachChairsStyle.sticky}
                    style={
                      vendor?.configuration.gridLineBreak
                        ? { marginBottom: "20px" }
                        : {}
                    }
                  >
                    <RowDivider name={`${row.name}`} />
                  </Box>
                  <Box
                    sx={LocationAvailabilitiesBeachChairsStyle.rowContent}
                    style={
                      vendor?.configuration.gridLineBreak
                        ? { display: "grid", gridGap: "20px" }
                        : {}
                    }
                  >
                    {row.rowData.map((beachChair) => (
                      <Box
                        onClick={() => {
                          dispatch(setRowRequest({ selectedRow: row }));
                          dispatch(
                            selectBeachChairRequest({
                              selectedBeachChair: beachChair,
                            })
                          );
                          dispatch(
                            selectBeachChairToBookingRequest({
                              beachChairId: beachChair.id,
                            })
                          );
                          dispatch(
                            redirectRequest({
                              path: `/s/strandkorb/${city?.name}/${section?.name}/${section?.id}/${beachChair.id}`,
                            })
                          );
                        }}
                        key={`${row.name}-${beachChair.id}`}
                      >
                        <AvailabilitiesBeachChair
                          id={beachChair.publicNumber}
                          timeEnum={beachChair.timeEnum}
                          hasLock={beachChair.lockId !== null}
                          isSeasonBeachChair={beachChair.seasonBeachChair}
                          selected={selectedId === beachChair.id}
                          attributes={beachChair.attributes}
                          showColor={showColor}
                          inBookingSelected={isDisabled(
                            inBookingSelectedIds.filter(
                              (item) => item.beachChairId === beachChair.id
                            ),
                            start,
                            end
                          )}
                          model={beachChair.model}
                        />
                      </Box>
                    ))}
                  </Box>
                </Fragment>
              )
          )
      ) : (
        <Box sx={LocationAvailabilitiesBeachChairsStyle.noData}>
          <Typography
            variant={"h2"}
            sx={LocationAvailabilitiesBeachChairsStyle.noData}
          >
            {preBooking
              ? t("bookingStartNotStarted", { city: vendor?.address.city })
              : t("noData")}
          </Typography>
          <Typography
            variant={"h3"}
            sx={{
              ...LocationAvailabilitiesBeachChairsStyle.noDataText,
              padding: 5,
            }}
          >
            {preBooking
              ? t("bookingStartNotStartedText", preBooking)
              : t("contactDirectly")}
          </Typography>
        </Box>
      )}
    </>
  );
};

export default AvailabilitiesBeachChairs;
